// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__10yB9","title":"Header_title__1yn3_","left":"Header_left__xdHc7","clinicName":"Header_clinicName__2a9bj"};